import { common } from '@ocean/ui'
import { DescriptionListProps } from '@ocean/ui/dist/components/common/DescriptionList/types'
import { DateUtils } from '@ocean/utils'
import { ListItemLayout, ListItemSegment } from 'layouts/lists'
import { ListItemInfo } from 'components/lists/common'
import { ListItemCommonProps } from 'components/lists/types'
import { Root, DescriptionListWrapper } from './ActivityLogDetailsListItem.styled'

const { DescriptionList } = common

// TODO: Fix with real API data
export type ActivityLogDetailsListItemProps = ListItemCommonProps & {
  time: number
  content: DescriptionListProps
}

const ActivityLogDetailsListItem: React.FC<ActivityLogDetailsListItemProps> = ({
  time,
  onClick,
  header,
  content,
}) => {
  function handleClick() {
    onClick && onClick()
  }

  return (
    <Root onClick={handleClick}>
      <ListItemLayout>
        <ListItemSegment segmentId='header'>
          <ListItemInfo info={header} dataTest='ActivityLogDetailsListItemHeader' />
        </ListItemSegment>
        <ListItemSegment segmentId='content'>
          <DescriptionListWrapper data-test='ActivityLogDetailsListItemContent'>
            <DescriptionList {...content} />
          </DescriptionListWrapper>
        </ListItemSegment>
        <ListItemSegment segmentId='sidebar'>
          <ListItemInfo
            info={DateUtils.formatShortDate(time)}
            dataTest='ActivityLogDetailsListItemSidebar'
          />
        </ListItemSegment>
      </ListItemLayout>
    </Root>
  )
}

export default ActivityLogDetailsListItem
